import { useState } from "react";
import { TextField } from "../common/inputFiled";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import oneSignalService from "../../../services/oneSignalService";



export default function AdminLogin() {
 
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: true,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simple validation
  
    const newErrors = {};
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.password) newErrors.password = "Password is required";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setLoading(true);
    const bodyData = new URLSearchParams();
    bodyData.append("email", formData.email);
    bodyData.append("password", formData.password);

    fetch(`${process.env.REACT_APP_API_BASE_URL}/admin/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: bodyData.toString(),
    })
      .then(async (response) => {
        if (!response.ok) {
          let errorMsg = "Login failed. Please try again.";
          try {
            const errorData = await response.json();
            if (errorData && errorData.message) errorMsg = errorData.message;
          } catch { }
          throw new Error(errorMsg);
        }
        return response.json();
      })
      .then((data) => {
        setLoading(false);
        // Extract token from API response and store in cookie
        try {
          const token = data?.data?.[0]?.admin?.token;
          if (token) {
            Cookies.set("admin_token", token, { expires: 7, sameSite: "Lax", path: "/" });
          }
        } catch {}
        
        // Associate admin with OneSignal (using admin_ prefix to distinguish from regular users)
        try {
          const adminData = data?.data?.[0]?.admin;
          if (adminData?.admin_id) {
            oneSignalService.setExternalUserId(`admin_${adminData.admin_id}`)
              .catch(() => {});
          }
        } catch {}
        
        toast.success(data.message || "Login Successfully");
        setTimeout(() => {
          window.location.href = "/admin/dashboard";
        }, 1200);
      })
      .catch((error) => {
        setLoading(false);
        setErrors({ api: error.message || "Login failed. Please try again." });
        toast.error(error.message || "Login failed. Please try again.");
      });
  };

  return (
    <div className="min-h-screen bg-[#F3F0FF] flex items-center justify-center px-4">
      <div className="w-full max-w-[520px] p-6 sm:p-8 md:p-10">
        {/* Logo + Title */}
        <div className="flex flex-col items-center gap-4 mb-8">
          {/* Logo */}
          <div className="h-20 w-20 rounded-xl bg-gradient-to-br from-[#7C4DFF] to-[#6A35FF] flex items-center justify-center shadow-md">
            <img src="./logo.svg" alt=" PhoneBookPlus Logo" />
          </div>

          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-500 font-inter">
             PhoneBookPlus(Admin)
          </h1>
        </div>

        {/* Form */}
        <form className="space-y-5" onSubmit={handleSubmit}>
          <TextField
            id="email"
            type="email"
            name="email"
            label="Email"
            placeholder="Enter Email"
            value={formData.email}
            onChange={handleChange}
            error={errors.email}
            disabled={loading}
          />
          <TextField
            id="password"
            type="password"
            name="password"
            label="Password"
            placeholder="Enter Password"
            value={formData.password}
            onChange={handleChange}
            error={errors.password}
            disabled={loading}
          />

             <div className="flex items-center justify-between">
            <label className="inline-flex items-center gap-2 cursor-pointer select-none">
              <input
                type="checkbox"
                name="rememberMe"
                className="h-4 w-4 accent-[#7C4DFF] rounded border-gray-300"
                checked={formData.rememberMe}
                onChange={handleChange}
                disabled={loading}
              />
              <span className="text-sm text-gray-700">Remember Me</span>
            </label>
            <a href="/admin/forgot-password" className="flex justify-end text-[#7c4ff9] text-sm">Forgot password?</a>
          </div>
          {errors.api && (
            <div className="text-red-500 text-sm mb-2">{errors.api}</div>
          )}
          <button
            type="submit"
            className="w-full rounded-3xl bg-gradient-to-b from-[#7c4ff9] to-[#47299c] py-3.5 text-white font-semibold shadow-lg shadow-[#7C4DFF]/25 hover:brightness-105 active:scale-[0.99] transition"
            disabled={loading}
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}